var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_c('div', {
    staticClass: "row d-flex mb-4 mb-xl-2 justify-content-between"
  }, [_c('h4', {
    staticClass: "col-12 col-xl-4 mb-2 mb-xl-0 font-weight-bold"
  }, [_vm._v(" 分店列表 ")]), _vm.hasBranchCreatePermission ? _c('div', {
    staticClass: "col-12 col-xl-8 d-flex flex-xl-row align-items-center align-items-xl-center justify-content-end"
  }, [_c('b-button', {
    directives: [{
      name: "b-modal",
      rawName: "v-b-modal",
      value: 'modal-create-branch',
      expression: "'modal-create-branch'"
    }],
    staticClass: "flex-shrink-0 mb-0 mr-2",
    attrs: {
      "variant": "primary"
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v("加入分店")])], 1) : _vm._e()]), _c('b-card-text', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('b-overlay', {
    attrs: {
      "rounded": "sm"
    }
  }, [_c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.branches,
      "fields": _vm.filteredFields,
      "empty-text": "尚未綁定分店",
      "show-empty": ""
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([_vm.hasBranchEditPermission ? {
      key: "cell(actions)",
      fn: function fn(data) {
        return [!data.item.unbound_at ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-warning"
          },
          on: {
            "click": function click($event) {
              return _vm.unboundBranch(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-link-variant-off"
        }), _vm._v(" 解除綁定 ")]) : _vm._e(), data.item.unbound_at ? _c('b-button', {
          staticClass: "mr-1",
          attrs: {
            "variant": "inverse-success"
          },
          on: {
            "click": function click($event) {
              return _vm.reboundBranch(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-link-variant"
        }), _vm._v(" 重新綁定 ")]) : _vm._e(), _c('b-button', {
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.deleteBranch(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete"
        }), _vm._v(" 刪除 ")])];
      }
    } : null], null, true)
  })], 1)], 1)]), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1)], 1)], 1), _c('b-modal', {
    attrs: {
      "id": "modal-create-branch",
      "title": "新增分店",
      "centered": ""
    },
    on: {
      "hidden": _vm.resetModal,
      "ok": _vm.handleEditGroupBranch
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function click($event) {
              return cancel();
            }
          }
        }, [_vm._v(" 取消 ")]), _c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "success"
          },
          on: {
            "click": function click($event) {
              return ok();
            }
          }
        }, [_vm._v(" 確認送出 ")])];
      }
    }])
  }, [_c('form', {
    ref: "form",
    on: {
      "submit": function submit($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.handleEditGroupBranch.apply(null, arguments);
      }
    }
  }, [_c('b-form-group', [_c('b-form-select', {
    attrs: {
      "options": _vm.myBranches
    },
    model: {
      value: _vm.branchId,
      callback: function callback($$v) {
        _vm.branchId = $$v;
      },
      expression: "branchId"
    }
  })], 1), _c('b-form-group', [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "id": "name",
      "placeholder": "請輸入綁定類型"
    },
    model: {
      value: _vm.boundType,
      callback: function callback($$v) {
        _vm.boundType = $$v;
      },
      expression: "boundType"
    }
  })], 1)], 1)])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }